import React from 'react'
import { IZOrderContextMenuPosition } from '../types'

const clamp = (value: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, value))

export const usePositions = (position: IZOrderContextMenuPosition) => {
  const { left, top } = React.useMemo(() => {
    const margin = 8
    const w = 220
    const h = 200
    const vw = typeof window !== 'undefined' ? window.innerWidth : 800
    const vh = typeof window !== 'undefined' ? window.innerHeight : 600
    return {
      left: clamp(position.x, margin, vw - w - margin),
      top: clamp(position.y, margin, vh - h - margin)
    }
  }, [position.x, position.y])

  return { left, top }
}
